/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Cmspost_Groups1Inputs */

const vi_cmspost_groups1 = /** @type {(inputs: Cmspost_Groups1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sản phẩm nhắc tới trong bài (tối đa ${i?.max})`)
};

/**

* @param {Cmspost_Groups1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_groups1 = /** @type {((inputs: Cmspost_Groups1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Groups1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_groups1(inputs)
});
export { cmspost_groups1 as "cmsPost_groups" }